import { StringValueObject } from '@/utils/value-objects/string/string-value-object.js';

export class ProbeId extends StringValueObject {}
